import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export const GOLD = "#E5C158";

export const Panel = ({ title, icon: Icon, action, to, children, className = "", testid, delay = 0 }) => (
  <section
    data-testid={testid}
    style={{ animationDelay: `${delay}ms` }}
    className={`dash-rise relative rounded-2xl border border-[#C9A227]/15 bg-[#12141F]/80 backdrop-blur-xl p-5 md:p-6 shadow-[0_4px_24px_rgba(0,0,0,0.4)] hover:border-[#E5C158]/40 transition-colors duration-300 ${className}`}
  >
    {title && (
      <div className="flex items-center justify-between mb-4">
        <h2 className="flex items-center gap-2 text-[11px] font-mono uppercase tracking-[0.2em] text-zinc-400">
          {Icon && <Icon className="w-4 h-4 text-[#E5C158]" />}{title}
        </h2>
        {to && (
          <Link to={to} className="flex items-center gap-1 text-xs text-[#E5C158] hover:text-white transition-colors" data-testid={`${testid}-link`}>
            {action}<ArrowUpRight className="w-3.5 h-3.5" />
          </Link>
        )}
      </div>
    )}
    {children}
  </section>
);

export const Stat = ({ label, value, unit, testid, tone = "text-white" }) => (
  <div>
    <p className="text-[10px] font-mono uppercase tracking-widest text-zinc-500">{label}</p>
    <p className={`font-mono font-bold text-2xl md:text-3xl tabular-nums ${tone}`} data-testid={testid}>
      {value}{unit && <span className="text-sm text-zinc-500 ml-1">{unit}</span>}
    </p>
  </div>
);

export const Bar = ({ value, max, color }) => (
  <div className="h-1.5 rounded-full bg-white/5 overflow-hidden">
    <div className="h-full rounded-full transition-[width] duration-700" style={{ width: `${max ? Math.max(4, (value / max) * 100) : 0}%`, background: color }} />
  </div>
);
